import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LightAccountService } from '../services/light-account/light-account.service';

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard implements CanActivate {

  constructor(private router: Router, private lightAccount: LightAccountService) {}

  canActivate(): boolean {
    if (localStorage.getItem('access_token')) {
      this.router.navigate([this.lightAccount.isLight() ? '/marketplace' : '/chat']);
    } else {
      this.router.navigate(['/auth/login']);
    }
    return true; // On bloque l'accès direct à `/`, on redirige
  }
}
